import React, { memo, Fragment, useCallback } from 'react';
import { useTheme, createUseStyles, Text, Icon } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import StepContent from "../StepContent";
import DownloadIcon from "../../icons/DownloadIcon";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'DownloadTemplate');
const ITEMS = [{
  title: 'cfm_label_requiremente_one',
  subtitle: 'cfm_label_requiremente_one_desc'
}, {
  title: 'cfm_label_requiremente_two',
  subtitle: 'cfm_label_requiremente_two_desc'
}, {
  title: 'cfm_label_requiremente_three',
  subtitle: 'cfm_label_requiremente_three_desc'
}];
var _ref2 = /*#__PURE__*/React.createElement(DownloadIcon, null);
const DownloadTemplate = _ref => {
  let {
    entityName,
    entityLabel,
    data,
    onExport,
    totals
  } = _ref;
  const theme = useTheme();
  const classes = useStyles();
  const {
    t,
    logEvent
  } = useWeb5Context();
  const onDownloadFull = useCallback(() => {
    logEvent({
      event: 'import',
      functionality: 'exportDataFile'
    });
    onExport(entityName, data.importType, true, data.syncNames);
  }, [data, entityName, onExport, logEvent]);
  const onDownloadEmpty = useCallback(() => {
    logEvent({
      event: 'import',
      functionality: 'exportEmptyFile'
    });
    onExport(entityName, data.importType, false, data.syncNames);
  }, [data.importType, data.syncNames, entityName, onExport, logEvent]);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.stepWrapper
  }, /*#__PURE__*/React.createElement(StepContent, null, /*#__PURE__*/React.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.rowIcon
  }, _ref2), /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, t('cfm_label_download_general_info'))), /*#__PURE__*/React.createElement("div", {
    className: classes.list
  }, ITEMS.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: classes.listItem
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classes.listItemIcon,
    name: "info",
    color: theme.colors.actionMajor[500]
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    className: classes.title,
    bold: true
  }, t(item.title)), /*#__PURE__*/React.createElement(Text, null, t(item.subtitle)))))), /*#__PURE__*/React.createElement("div", {
    className: classes.boxes
  }, !!totals && /*#__PURE__*/React.createElement("div", {
    className: `${classes.box} imports__download-file-data`,
    onClick: onDownloadFull
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classes.boxIcon,
    color: theme.colors.actionMinor[500],
    name: "file"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.boxContext
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.topBox
  }, /*#__PURE__*/React.createElement(Text, {
    color: theme.colors.semantic.info500,
    type: "subtitle",
    bold: true
  }, t('cfm_label_download_file_with_data')), /*#__PURE__*/React.createElement(Icon, {
    color: theme.colors.actionMinor[500],
    name: "downloadAlt"
  })), /*#__PURE__*/React.createElement(Text, {
    color: theme.colors.textLight.secondary
  }, t('cfm_label_download_file_with_data_desc')))), /*#__PURE__*/React.createElement("div", {
    className: `${classes.box} imports__download-empty-file`,
    onClick: onDownloadEmpty
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classes.boxIcon,
    color: theme.colors.actionMinor[500],
    name: "emptyFile"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.boxContext
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.topBox
  }, /*#__PURE__*/React.createElement(Text, {
    color: theme.colors.semantic.info500,
    type: "subtitle",
    bold: true
  }, t('cfm_label_download_empty_file')), /*#__PURE__*/React.createElement(Icon, {
    color: theme.colors.actionMinor[500],
    name: "downloadAlt"
  })), /*#__PURE__*/React.createElement(Text, {
    color: theme.colors.textLight.secondary
  }, t('cfm_label_download_empty_file_desc'))))))));
};
process.env.NODE_ENV !== "production" ? DownloadTemplate.propTypes = {} : void 0;
export default /*#__PURE__*/memo(DownloadTemplate);